<template>
<temp-default>
    <div class="bl_result">
        <div
            class="bl_bottomMenu_inner ly_bottomMenu_inner">
            <span class="result_title">計算結果</span>
            <div class="bl_bottomMenu_inner_result ly_bottomMenu_inner_result">
                <!-- TODO 計算結果の数値を受け取りたいです -->
                <div class="bl_bottomMenu_inner_result_box">
                    日よけ効果係数(冷房期)
                    <span class="bl_bottomMenu_inner_result_box_value">{{gamma_cooling}}</span>
                </div>
                <div class="bl_bottomMenu_inner_result_box">
                    日よけ効果係数(暖房期)
                    <span class="bl_bottomMenu_inner_result_box_value">{{gamma_heating}}</span>
                </div>
            </div>
            <app-button
                name="PDF出力する"
                @click="report"
                class="btn_pdf big"
            />
            
            <app-button
                name="入力に戻る"
                @click="toForm"
                class="btn_toForm inline"
            />
        </div>
    </div>
    
    <!-- pdfダウンロード用の非表示要素 -->
    <div id="invisible" style="display: none;"/>
</temp-default>
</template>

<script>
import AppButton from '@/components/atoms/AppButton.vue'
import TempDefault from '@/components/templates/TempDefault.vue'
import { mapActions, mapGetters} from 'vuex'
import { mapComputedProperties } from '@/util'

export default {
    name: 'Index',
    components: {
        AppButton,
        TempDefault
    },
    data(){
        return {
        }
    },
    computed:{
        ...mapGetters({
            data:'getAll'
        }),
        ...mapComputedProperties([
            'gamma_cooling',
            'gamma_heating'
        ])
    },
    methods: {
        ...mapActions([
            'report',
            'update'
        ]),
        toForm(){
            this.$router.push('/form')
        }
    }
}
</script>

<style scoped>

/* 下の固定メニュー */
.ly_bottomMenu_inner{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
    padding: 0 8px 8px;
}
.bl_bottomMenu_inner_result{
    background-color: white;
    border: 2px solid #53BFD8;
    border-radius: 8px;
}
.ly_bottomMenu_inner_result{
    display: flex;
    flex-direction: column;
    padding: 8px;
}
.bl_bottomMenu_inner_result_box{
    padding: 4px 16px;
}
.bl_bottomMenu_inner_result_box:first-of-type{
    border-bottom: 1px solid #53BFD8;
}
.btn_calc{
    width: 200px;
    height: 50px;
    margin-top: -20px;
    font-size: 24px;
    letter-spacing: 0.2em;
}
.bl_bottomMenu_inner_result {
    margin: 50px auto;
}
.result_title,
.bl_bottomMenu_inner_result_box{
    display: inline-flex;
    align-items: center;
    margin: 0;
    font-size: 16px;
    font-weight: bolder;
}
.bl_bottomMenu_inner_result_box_value{
    margin-left: 8px;
    font-size: 24px;
}
_:-ms-lang(x)::-ms-backdrop, .ly_bottomMenu_inner{
    justify-content: center;
}
_:-ms-lang(x)::-ms-backdrop, .ly_bottomMenu_inner .result_title{
    margin-right: 8px;
}
.btn_pdf{
    padding: 8px 50px;
    font-size: 18px;
    background: linear-gradient(#6dc7dd, #41b8d4);
    border-radius: 8px;
}
.btn_toForm{
    margin-top: 20px;
}
/* レスポンシブ（タブレット縦よりウインドウ幅が狭いもの） */
@media screen and (max-width: 1000px) {
    .ly_bottomMenu{
        left: calc(50vw - 50% + 30px);
    }
    .ly_bottomMenu_inner{
        flex-wrap: wrap;
    }
}
</style>